module.exports = __webpack_public_path__ + "img/coins.3670464d.png";